import { render, staticRenderFns } from "./ViewFileModal.vue?vue&type=template&id=3a8f6f97&scoped=true"
import script from "./ViewFileModal.vue?vue&type=script&lang=js"
export * from "./ViewFileModal.vue?vue&type=script&lang=js"
import style0 from "./ViewFileModal.vue?vue&type=style&index=0&id=3a8f6f97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8f6f97",
  null
  
)

export default component.exports